/*
 * @Descripttion:
 * @Author: 01387189
 * @Date: 2021-05-20 10:42:02
 * @LastEditors: 01387189
 * @LastEditTime: 2021-05-26 00:53:47
 */
const Platform = {};

Platform.getUA = function (userAgent) {
  if (userAgent && typeof userAgent === "string") {
    return userAgent;
  }
  return navigator.userAgent;
};

Platform.isiPhone = function (userAgent = "") {
  return (
    this.getUA(userAgent).match(/iPhone/i) != null ||
    this.getUA(userAgent).match(/iPad/i) != null
  );
};

/**
 * 只能在浏览器判断
 * @param userAgent
 * @returns {boolean}
 */
Platform.isiPhoneX = function (userAgent = "") {
  const ua = this.getUA(userAgent);
  const width = window.screen.width;
  const height = window.screen.height;
  if (/iphone/gi.test(ua)) {
    /* iPhone X、iPhone XS */
    const x = width === 375 && height === 812;
    /* iPhone XS Max */
    const xsMax = width === 414 && height === 896;
    /* iPhone XR */
    const xR = width === 414 && height === 896;
    if (x || xsMax || xR) {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
};

Platform.isAndroid = function (userAgent = "") {
  return this.getUA(userAgent).match(/Android/i) != null;
};

Platform.isApp = function (userAgent = "") {
  return this.getUA(userAgent).match(/DigHouse/i) != null;
};

/**
 * 微信环境，微信浏览器+微信小程序webview
 * @param userAgent
 * @returns {boolean}
 */
Platform.isWx = function (userAgent = "") {
  return (
    this.getUA(userAgent)
      .toLowerCase()
      .match(/MicroMessenger/i) == "micromessenger"
  );
};

/**
 * 微信浏览器环境
 * @param userAgent
 * @returns {boolean}
 */
Platform.isWxBrowser = function (userAgent = "") {
  return this.isWx() && !this.isWxxcx();
};

/**
 * 是否微信小程序环境,页面加载后调用
 * @returns {boolean | boolean | ""}
 */
Platform.isWxxcx = function () {
  return window.__wxjs_environment === "miniprogram";
};

Platform.isMoible = function (userAgent = "") {
  const ua = this.getUA(userAgent);
  return /iphone|ipod|ipad|ipad|Android|nokia|blackberry|webos|webos|webmate|bada|lg|ucweb|skyfire|sony|ericsson|mot|samsung|sgh|lg|philips|panasonic|alcatel|lenovo|cldc|midp|wap|mobile|sfsgsweb/i.test(
    ua.toLowerCase()
  );
};

/**
 * 本地环境
 * @returns {boolean}
 */
Platform.isLocalhost = function () {
  return (
    process.env.NODE_ENV === "development" || location.hostname === "localhost"
  );
};

/**
 * 测试环境
 * @returns {boolean}
 */
Platform.isSit = function () {
  return location.hostname.indexOf(".sit.") != -1;
};

/**
 * 生产环境
 */
Platform.isProduction = function () {
  // 特别注意:ios不支持正则表达式的断言，如下代码会报错
  // return /(?<!\.sit)\.sf-express\.com$/gi.test(location.hostname);
  return (
    /^.*\.sf-express\.com$/gi.test(location.hostname) &&
    !/^.*\.sit\.sf-express\.com$/gi.test(location.hostname)
  );
};

/**
 * h5环境
 * @returns {boolean}
 */
Platform.isAcsp = function () {
  return location.hostname.indexOf("acsp.") != -1;
};

/**
 * 是否丰源app
 * @param userAgent
 * @returns {boolean}
 */
Platform.isFYApp = function (userAgent = "") {
  return this.getUA(userAgent).toLowerCase() === "sfsgsweb";
};

/**
 * 是否丰声app
 * @param userAgent
 * @returns {boolean}
 */
Platform.isFSApp = function (userAgent = "") {
  return (
    this.getUA(userAgent)
      .toLowerCase()
      .match(/sf-service-mobile/i) === "sf-service-mobile"
  );
};

export default Platform;
